import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/training/programmes', params),
    getById: (id) => Api.get('/training/programme/' + id, null),
    save: (entity) => Api.post('/training/programme', entity),
    update: (id, entity) => Api.put('/training/programme/' + id, entity),
    delete: (id) => Api.delete('/training/programme/' + id),
    search: (searchText) => Api.get('/training/programmes/search', {q: searchText}),
    getCourses: (id) => Api.get('/training/programme/' + id + '/courses'),
    addCourse: (id, courseId) => Api.post('/training/programme/' + id + '/course', {courseId: courseId}),
    removeCourse: (id, courseId) => Api.delete('/training/programme/' + id + '/course/' + courseId),
};